import React, { useState } from "react";
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";

interface SupportData {
    id: number;
    title: string;
    description: string;
    submittedDate: string;
    status: "Pending" | "Resolved";
    priority: "Low" | "Medium" | "High";
    category: string;
    adminReply?: string;
}

const ViewAdminSupport = () => {
    const navigate = useNavigate();
    const [subTab, setSubTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");

    const subTabs: ("Pending" | "Resolved")[] = ["Pending", "Resolved"];

    const [supportData, setSupportData] = useState<SupportData[]>([
        {
            id: 1,
            title: "App not loading",
            description: "The app freezes when I open it.",
            submittedDate: "20 Oct 2025",
            status: "Pending",
            priority: "High",
            category: "Technical Issue",
        },
        {
            id: 2,
            title: "Refund not processed",
            description: "I haven't received my refund yet.",
            submittedDate: "19 Oct 2025",
            status: "Resolved",
            priority: "Medium",
            category: "Payments",
            adminReply: "Refund has been initiated and will reflect in 3–5 days.",
        },
        {
            id: 3,
            title: "Chat not connecting",
            description: "Unable to send or receive messages.",
            submittedDate: "18 Oct 2025",
            status: "Pending",
            priority: "Low",
            category: "Chat Support",
        },
    ]);

    const filteredData = supportData.filter(
        (item) => item.status === subTabs[subTab]
    );

    const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSubTab(newValue);
    };

    return (
        <>
            <div className="main_title">
                <h1>Admin Support Management View</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    <button onClick={() => navigate("/admin-support")}>
                        Admin Support Management
                    </button>{" "}
                    - View
                </p>
            </div>

            <Box className="custom_tabs1 mt_20">
                <Tabs
                    value={subTab}
                    onChange={handleSubTabChange}
                    className="custom_tabs_links"
                >
                    {subTabs.map((label, index) => (
                        <Tab key={index} label={label} />
                    ))}
                </Tabs>
            </Box>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </div>
                </div>

                <TableContainer className="table_container mt_20">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Category</TableCell>
                                <TableCell>Priority</TableCell>
                                <TableCell>Submitted Date</TableCell>

                                {subTabs[subTab] === "Resolved" && (
                                    <TableCell>Admin Reply</TableCell>
                                )}

                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData.map((row, index) => (
                                <TableRow key={row.id} hover>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{row.title}</TableCell>
                                    <TableCell>{row.description}</TableCell>
                                    <TableCell>{row.category}</TableCell>
                                    <TableCell>{row.priority}</TableCell>
                                    <TableCell>{row.submittedDate}</TableCell>

                                    {subTabs[subTab] === "Resolved" && (
                                        <TableCell>{row.adminReply || "-"}</TableCell>
                                    )}

                                    <TableCell>
                                        <div className="table_actions v2">
                                            <Box>
                                                <IconButton>
                                                    <img
                                                        src="/static/images/trash2_icon.svg"
                                                        alt="Delete"
                                                    />
                                                </IconButton>
                                            </Box>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}

                            {filteredData.length === 0 && (
                                <TableRow>
                                    <TableCell
                                        colSpan={subTabs[subTab] === "Resolved" ? 7 : 6}
                                        align="center"
                                    >
                                        No records found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default ViewAdminSupport;
